(function () {
  'use strict';

  if (window.__lsRuntimeMonitor && window.__lsRuntimeMonitor.init) return;

  var state = {
    init: true,
    startedAt: Date.now(),
    events: [],
    maxEvents: 120,
    version: '1.0.0'
  };

  function push(type, data, level) {
    try {
      var item = {
        t: new Date().toISOString(),
        type: type,
        data: data || {}
      };
      state.events.push(item);
      if (state.events.length > state.maxEvents) state.events.shift();

      var fn = (level === 'error' && console.error) || (level === 'warn' && console.warn) || console.log;
      if (fn) fn.call(console, '[LS Monitor]', type, item.data);
    } catch (e) {
      // never throw from monitor
    }
  }

  function safeNow() {
    try { return Math.round(performance.now()); } catch (e) { return null; }
  }

  window.__lsRuntimeMonitor = {
    state: state,
    push: push,
    getEvents: function () { return state.events.slice(); }
  };

  push('init', {
    path: location.pathname,
    pageType: document.body ? document.body.className : '',
    uaMobile: /Mobi|Android/i.test(navigator.userAgent)
  });

  window.addEventListener('error', function (e) {
    push('window.error', {
      message: e && e.message,
      source: e && e.filename,
      line: e && e.lineno,
      col: e && e.colno
    }, 'error');
  }, true);

  window.addEventListener('unhandledrejection', function (e) {
    var reason = e && e.reason;
    push('unhandledrejection', {
      message: reason && reason.message ? reason.message : String(reason)
    }, 'error');
  });

  window.addEventListener('load', function () {
    setTimeout(function () {
      try {
        var nav = performance.getEntriesByType && performance.getEntriesByType('navigation');
        if (nav && nav[0]) {
          var n = nav[0];
          push('navigation', {
            domContentLoaded: Math.round(n.domContentLoadedEventEnd),
            loadEventEnd: Math.round(n.loadEventEnd),
            transferSize: n.transferSize || 0,
            encodedBodySize: n.encodedBodySize || 0,
            decodedBodySize: n.decodedBodySize || 0,
            type: n.type || ''
          }, (n.loadEventEnd > 5000 ? 'warn' : undefined));
        }

        if (performance.getEntriesByType) {
          var resources = performance.getEntriesByType('resource') || [];
          var slow = [];
          for (var i = 0; i < resources.length; i++) {
            var r = resources[i];
            if (!r || !r.name) continue;
            if (r.duration > 2500) {
              slow.push({
                name: r.name.slice(0, 180),
                duration: Math.round(r.duration),
                initiatorType: r.initiatorType || ''
              });
              if (slow.length >= 8) break;
            }
          }
          if (slow.length) push('slow_resources', { count: slow.length, items: slow }, 'warn');
        }
      } catch (e) {
        push('monitor.capture_failed', { message: String(e) }, 'warn');
      }
    }, 0);
  });

  try {
    if ('PerformanceObserver' in window) {
      var po = new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (!entry) continue;

          if (entry.entryType === 'longtask' && entry.duration > 200) {
            push('longtask', {
              duration: Math.round(entry.duration),
              startTime: Math.round(entry.startTime)
            }, 'warn');
          }

          if (entry.entryType === 'resource' && entry.duration > 4000) {
            push('resource.runtime_slow', {
              name: (entry.name || '').slice(0, 180),
              duration: Math.round(entry.duration),
              initiatorType: entry.initiatorType || ''
            }, 'warn');
          }
        }
      });

      var supported = [];
      try { supported = PerformanceObserver.supportedEntryTypes || []; } catch (e) {}
      if (supported.indexOf('longtask') !== -1) po.observe({ type: 'longtask', buffered: true });
      if (supported.indexOf('resource') !== -1) po.observe({ type: 'resource', buffered: true });
    }
  } catch (e) {
    push('observer_init_failed', { message: String(e) }, 'warn');
  }

  var watchdogMs = 12000;
  setTimeout(function () {
    push('heartbeat', {
      elapsedMs: Date.now() - state.startedAt,
      readyState: document.readyState,
      perfNow: safeNow()
    });
  }, watchdogMs);
})();